import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs';
const getPointExchanges = (merchantId) => {
	return Client.get(`${baseUrl}/manage-point/${merchantId}/exchanges`);
};

const postPointExchanges = (merchantId, data) => {
	return Client.post(`${baseUrl}/manage-point/${merchantId}/exchanges`, data);
};

const rules = (merchantId, data) => {
	return Client.get(`${baseUrl}/manage-point-redeem/${merchantId}/rules`, data);
};

const addRules = (merchantId, data) => {
	return Client.post(
		`${baseUrl}/manage-point-redeem/${merchantId}/rules`,
		data
	);
};

const updateRules = (merchantId, data, id) => {
	return Client.put(
		`${baseUrl}/manage-point-redeem/${merchantId}/rules/${id}`,
		data
	);
};

export default {
	rules,
	addRules,
	updateRules,
	getPointExchanges,
	postPointExchanges,
};
